import { useState, useRef, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import MainLayout from '../../Layouts/Main_Layout';
import Header from "../../Header/header";
import HeaderMenu from "../../Header/header-menu";
import Isi from "../../ISI/Isi";
import IsiFrame from "../../ISI/Isi-frame";
import Footer from "../../Footer/Footer";

import './Carepartner-Resources.css';

import { Button, Modal } from 'react-bootstrap';

export default function CarepartnerResources() {
  const myRef = useRef(null)
  const findResourcesRef = useRef(null)
  const submenu = useRef(null)
  const storiesRef = useRef(null)
  const talkDoctorRef = useRef(null)
  const whatIsRef = useRef(null)
  const navigate = useNavigate();
  
  let location = useLocation();
  const [show, setShow] = useState(true)
  const [whatIsInbrija, setWhatIsInbrija] = useState(false)
  const [carepartnerStories, setCarepartnerStories] = useState(false)
  const [talkToDoctor, setTalkToDoctor] = useState(false)
  const [findResources, setFindResources] = useState(false)
  const [videoState, setVideoState] = useState(false);

  const executeScroll = () => {
    myRef.current.scrollIntoView();
    setShow(true)
  }

  const getChromeVersion = () => {
    var raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
    if (raw) {
      return parseInt(raw[2], 10);
    }
    else {
      return 100;
    }
  }
  
  const ModalwithHash = () => {
    let el = document.querySelector(".modal.show");
    const video = el.querySelector("video");
    if(video !== null) {
      video.muted = false;
      let playbackerror = video.play();
      let trackElem = null
      if(el !== null) {
        trackElem = el.querySelector("track");
      } 
      if (playbackerror !== undefined) {
        playbackerror
          .then(function () {
            // Autoplay started!
            if (trackElem !== null) {
              let track1 = trackElem.track;
              track1.mode = "hidden";
            }
          })
          .catch(function (error) {
            if (trackElem !== null) {
              let track = trackElem.track;
              track.mode = "showing";
            }
            video.muted = true;
            video.play();
          });
      }
    }
  };

  const scrollToAnchor = (anchorName) => {
    const element = document.getElementById(anchorName);
    const savingRefOffset = 45;
    var savingRefPosition = element.getBoundingClientRect().top;
    var savingRefOffsetPosition = savingRefPosition + window.pageYOffset - savingRefOffset;

    if (getChromeVersion() > 60) {
      window.scrollTo({
        top: savingRefOffsetPosition,
        behavior: "smooth"
      });
    }
    else {
      window.scrollTo(0, savingRefOffsetPosition);
    }
  }

  useEffect(() => {
    setTimeout(() => {
      if (location.hash === '#full-ISI') {
        var element = myRef.current;
        var headerOffset = 39;
        var elementPosition = element.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
        if (getChromeVersion() > 60) {
          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
          });
        }
        else {
          window.scrollTo(0, offsetPosition);
        }
      }
    }, 1000);

    // const submenuItems = document.querySelectorAll('.submenu-style div')
    const componentElement = myRef.current;
    const offsetTop = componentElement.offsetTop;

    const element1 = document.getElementById("what-is-inbrija");
    let offsetTop1 = element1.offsetTop - 100;

    const element2 = document.getElementById("carepartner-stories");
    let offsetTop2 = element2.offsetTop - 100;
    let offsetTopBottom2 = element1.offsetTop - 100;
    
    const element3 = document.getElementById("talk-to-their-doctor");
    let offsetTop3 = element3.offsetTop - 100;
    const offsetTopBottom3 = element2.offsetTop;
    
    const element4 = document.getElementById("find-resources");
    let offsetTop4 = element4.offsetTop - 100;
    const offsetTopBottom4 = element3.offsetTop;
    
    const calculateOffset = () => {

      if (myRef) {
        function handleScroll() {

          if(document.getElementById("what-link")) {
            if (window.scrollY > offsetTop1 && window.scrollY < offsetTop2) {
              document.getElementById('what-link').classList.add('submenu-style-active');
            }
            if (window.scrollY > offsetTop2 || window.scrollY < offsetTop1) {
              document.getElementById('what-link').classList.remove('submenu-style-active');
              document.getElementById('what-link').classList.add('submenu-style-not-active');
            }
          }

          if(document.getElementById("carepartner-link")) {
            if (window.scrollY > offsetTop2 && window.scrollY < offsetTop3) {
              document.getElementById('carepartner-link').classList.add('submenu-style-active');
            }
            if (window.scrollY > offsetTopBottom3 || window.scrollY < offsetTop2) {
              document.getElementById('carepartner-link').classList.remove('submenu-style-active');
              document.getElementById('carepartner-link').classList.add('submenu-style-not-active');
            }
          }

          if(document.getElementById("talk-doctor-link")) {
            if (window.scrollY > offsetTop3 && window.scrollY < offsetTop4) {
              document.getElementById('talk-doctor-link').classList.add('submenu-style-active');
            }
            if (window.scrollY > offsetTopBottom4 || window.scrollY < offsetTop3) {
              document.getElementById('talk-doctor-link').classList.remove('submenu-style-active');
              document.getElementById('talk-doctor-link').classList.add('submenu-style-not-active');
            }
          }

          if(document.getElementById("resources-link")) {
            if (window.scrollY > offsetTop4) {
              document.getElementById('resources-link').classList.add('submenu-style-active');
            }
            else {
              document.getElementById('resources-link').classList.remove('submenu-style-active');
              document.getElementById('resources-link').classList.add('submenu-style-not-active');
            }
          }
          if (window.innerHeight + window.scrollY > offsetTop) {
            setShow(false);
          }
          else (
            setShow(true)
          )
        }

        window.addEventListener("scroll", handleScroll);


        return () => {
          window.removeEventListener("scroll", handleScroll);
        };
      }
    };
    calculateOffset();
    window.addEventListener('resize', calculateOffset);

    if (location.pathname === '/carepartner-resources' || location.pathname === '/carepartner-resources/') {
      var windowHeight = window.innerHeight;
      var header = document.getElementById('submenu');

      window.addEventListener('scroll', function () {
        var scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

        if (scrollPosition > windowHeight) {
          header.classList.add('sticky');
        } else {
          header.classList.remove('sticky');
        }
      });
    }

    switch (location.hash) {
      case "#what-is-inbrija":
        scrollToAnchor("what-is-inbrija");
        setWhatIsInbrija(true);
        setCarepartnerStories(false);
        setTalkToDoctor(false);
        setFindResources(false);
        break;
      case "#carepartner-stories":
        scrollToAnchor("carepartner-stories")
        setWhatIsInbrija(false);
        setCarepartnerStories(true);
        setTalkToDoctor(false);
        setFindResources(false);
        break;
      case "#talk-to-their-doctor":
        scrollToAnchor("talk-to-their-doctor")
        setWhatIsInbrija(false);
        setCarepartnerStories(false);
        setTalkToDoctor(true);
        setFindResources(false);
        break;
      case "#find-resources":
        scrollToAnchor("find-resources")
        setWhatIsInbrija(false);
        setCarepartnerStories(false);
        setTalkToDoctor(false);
        setFindResources(true);
        break;
      default:
        break;
    }

    return () => {
      window.removeEventListener('resize', calculateOffset);
    };
  }, [location]);

  return (
    <MainLayout>
      <div id='carepartner-resources-page'>
        <Helmet>
          <title>Information for Care Partner Resources on INBRIJA® (levodopa inhalation powder) | INBRIJA® (levodopa inhalation powder)</title>
          <meta property='og:title' content={`Information for Care Partner Resources on INBRIJA® (levodopa inhalation powder) | INBRIJA® (levodopa inhalation powder)`} />
          <meta property='og:description' content={`View resources and get guidance on using INBRIJA, storage information, and answers to frequently asked questions. See Indication, Important Safety Information, and Patient Information Leaflet.`} />
          <meta property='og:site_name' content='INBRIJA.COM' />
          <meta property='og:type' content='website' />
          <meta name='description' content={`View resources and get guidance on using INBRIJA, storage information, and answers to frequently asked questions. See Indication, Important Safety Information, and Patient Information Leaflet.`} />
          <meta property="og:image" content="https://inbrija.com/assets/images/Inbrija-OG-Image.jpg" />
          <meta property='og:url' content='https://inbrija.com/for-people-on-inbrija' />
          <meta property='og:image:alt' content='INBRIJA logo' />
        </Helmet>
        <Header />
        <HeaderMenu>
          <div className='hero-section-carepartner'>
            <div className="container-1500">
              <div id="help-loved" className='hero-section-content'>
                <h1>Help your loved one</h1>
                <div><img src="/assets/images/paintbrush-fightback.png" className='img-fluid desktop-image my-3' alt="Fight Back" loading="lazy" /></div>
                <h4>against returning Parkinson’s symptoms</h4>
                <div className="actor_portrayal position-absolute">Actor portrayal.</div>
              </div>
            </div>
          </div>
        </HeaderMenu>

        {/* //@TODO this should be it's own component, with values passed to it and it's functionality contained within. repeating it on each page is dumb */}
        <div className='menu-bar-sticky-desktop'>
          <div className="brush-style-2" id="submenu" ref={submenu}>
            <div className="submenu-style">
              <Link className='text-decoration-none' to="/carepartner-resources#what-is-inbrija">
                <div id='what-link' className={whatIsInbrija ? 'submenu-style-active pointer' : 'submenu-style-not-active pointer'}>What is INBRIJA?</div>
              </Link>
              <Link className='text-decoration-none' to="/carepartner-resources#carepartner-stories">
                <div id='carepartner-link' className={carepartnerStories ? 'submenu-style-active pointer' : 'submenu-style-not-active pointer'}>Hear Care Partner Stories</div>
              </Link>
              <Link className='text-decoration-none' to="/carepartner-resources#talk-to-their-doctor">
                <div id='talk-doctor-link' className={talkToDoctor ? 'submenu-style-active pointer' : 'submenu-style-not-active pointer'}>Talk to Their Doctor</div>
              </Link>
              <Link className='text-decoration-none' to="/carepartner-resources#find-resources">
                <div id='resources-link' className={findResources ? 'submenu-style-active pointer' : 'submenu-style-not-active pointer'}>Find Resources</div>
              </Link>
            </div>
          </div>
        </div>

        <div className="carepartner-container pt-5" id="what-is-inbrija" ref={whatIsRef}>
          <div className="carepartner-container-title-section">
            <div className="container">
              <h2 className='text-dpurple'>INBRIJA can help rescue the moments that matter to you and your loved one</h2>
            </div>
          </div>
        </div>

        <div className="d-md-none">
          <img src="/assets/images/bg-carepartners-mobile.png" />
        </div>

        <div className="carepartner-brush-callout text-center mb-5">
          <div className="carepartner-brush-callout-copy">
            <p className="pt-5">INBRIJA is an on-demand levodopa inhaler that helps address the return of Parkinson's disease (PD) symptoms (also known as OFF episodes) while regular oral medication takes effect.</p>
            <p>With INBRIJA, returning PD symptoms can start to be managed in as early as 10 minutes.* This may help your loved one return to their day, without having to wait for the next dose of their medication.</p>
          </div>
        </div>

        <section id="description" className="container mb-5">
          <h5 className="text-left fw-bold ms-3 mb-4 text-dpurple">INBRIJA is:</h5>
          <div className="description-item row text-left me-md-5">
            <div className="col-12 col-md-4 d-flex flex-column flex-md-row">
              <div className="desc-image">
                <img src="/assets/images/icon-fast-acting.png" className='desktop-image' alt="Fast acting icon" loading="lazy" />
              </div>
              <div className="desc-copy">
                <p>Fast-acting, with clinical improvements starting  as early as 10 minutes*</p>
              </div>
            </div>
            <div className="col-12 col-md-4 d-flex flex-column flex-md-row">
              <div className="desc-image">
                <img src="/assets/images/icon-inhaled.png" className='desktop-image' alt="Inhaled icon" loading="lazy" />
              </div>
              <div className="desc-copy">
                <p>Inhaled as needed, in addition to regular carbidopa/levodopa medication</p>
              </div>
            </div>
            <div className="col-12 col-md-4 d-flex flex-column flex-md-row">
              <div className="desc-image">
                <img src="/assets/images/icon-portable.png" className='desktop-image' alt="Lightweight portable icon" loading="lazy" />
              </div>
              <div className="desc-copy">
                <p>Lightweight, portable and easy to use</p>
              </div>
            </div>
          </div>
          <p className="disclaimer text-center">*In a large clinical trial, INBRIJA significantly improved motor symptoms in 30 minutes, with improvements starting as early as 10 minutes. Results may vary.</p>
        </section>

        <hr className="container" />

        <section id="carepartner-stories" ref={storiesRef}>
          <div className="carepartner-container-title-section carepartner-container">
            <h2 className="mb-5">Hear stories from other care partners</h2>
            <p className="w-75 mx-auto">Meet Bernadette and Kristi, who are both caring for their husbands with PD. Watch as they share their inspiring journeys and how INBRIJA has helped their loved ones fight back.</p>
          </div>

          <div className="brush-bg">
            <div className="carepartner-stories-video">
              <Button onClick={() => setVideoState(true)} variant="">
                <img src="/assets/images/poster-carepartner-09-2026.jpg"  className="img-fluid desktop-image" alt="A still of a video about Inbrija Care Partners" loading="lazy" />
              </Button>
            </div>
            <h2 id="talk-to-their-doctor" ref={talkDoctorRef} className="mb-5 text-dpurple">Support your fighter at their next appointment</h2>
            <p className="w-80 w-md-100 mx-auto">At the next checkup, it’s important to speak up to your loved one’s doctor about how they’re feeling, including:</p>
            <ul className="carepartner-list">
              <li>When and where symptoms are returning</li>
              <li>How returning symptoms are affecting their daily life</li>
              <li>What activities they’re missing out on because of symptom return</li>
            </ul>
            <h3 className="fw-bold pb-5 mb-0 px-5 text-dpurple">You play a vital role in advocating for your loved one’s care. <br /> Ask their doctor if INBRIJA may be right for them.</h3>
          </div>

          <div id="find-resources" ref={findResourcesRef} className="dark-bg">
            <div className="container py-5">
              <div className="d-flex flex-column-reverse flex-md-row">
                <div className="col-12 col-md-6 text-white text-center">
                  <p><strong>Remember that</strong></p>
                  <img src="/assets/images/paintbrush-notalone.png" className="img-fluid desktop-image d-block mx-auto mb-3" alt="Not Alone" loading="lazy" />
                  <p className="mb-5 text-lgray">By downloading our care partner brochure, you can find more helpful information and tips on how to prepare for your loved one's next doctor's appointment.</p>
                  <p className="mb-3"><a href="/pdfs/carepartner-brochure.pdf" target="_blank"><button download="/pdfs/carepartner-brochure.pdf" target="_blank" className="cp-button">Download Care Partner Brochure</button></a></p>
                  <p className="mb-5"><button onClick={() => {navigate('/what-are-off-periods')}} className="cp-button">Learn More About Symptom Return</button></p>
                </div>
                <div className="col-12 col-md-5 offset-md-1">
                  <img src="/assets/images/Brochure_Mock_FINAL.jpg" className="img-fluid desktop-image d-block mx-auto " alt="" loading="lazy" />
                </div>
              </div>
            </div>
          </div>

          <Modal show={videoState} dialogClassName="video-modal" centered onEntered={ModalwithHash}>
            <div className="modal-close">
              <div className="close-modal" onClick={() => setVideoState(false)}>
                <div className="close-modal-left "></div>
                <div className="close-modal-right"></div>
              </div>
            </div>
            <Modal.Body className="video-modal-alignment video-modal-background">
              <div className="multiple-videos-container">
                <video controls autoPlay playsInline className="video-width" type="video/mp4" title="Care Partner Convos">
                  <source src="/videos/patient-videos-carepartner-conversations.mp4" type="video/mp4" />
                  <track src="/videos/patient-videos-carepartner-conversations.vtt" kind="captions" srcLang="en" label="English" default />
                </video>
              </div>
              <div className="video-instructions">
                <a href="https://inbrija.com/prescribing-information.pdf" target='_blank' rel="noreferrer" className="video-inst">
                  Please see Full Prescribing Information
                </a>
                <a target="_blank" href="/videos/patient-videos-carepartner-conversations-transcript.html" className="video-inst" rel="noopener">Read Transcript</a>
              </div>
            </Modal.Body>
          </Modal>

        </section>
        <div ref={myRef}>
          <Isi />
        </div>
        {show ?
          <IsiFrame onClick={executeScroll} /> : ''}
        <Footer year="2026" partNum="M-INB-US-0142 10/26"
          facebookLink="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fwww.inbrija.com%2Fpeople-on-inbrija&title=Tips%20and%20information%20about%20INBRIJA&description=Resources%20to%20help%20you."
          twitterCode="https://twitter.com/intent/tweet?text=Tips%20and%20information%20about%20INBRIJA.%20Resources%20to%20help%20you.%20https://www.inbrija.com/people-on-inbrija" />
      </div>
    </MainLayout>
  )
}